module.exports = __webpack_public_path__ + "static/media/addExternalCall.372e760b.svg";